import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser'; // <--- IMPORTANT IMPORT
import { 
  BarChart3, Database, Workflow, Zap, Menu, X, CheckCircle2, ArrowRight, 
  MapPin, Phone, Mail, Linkedin, Facebook, TrendingUp, BrainCircuit, 
  Factory, Calculator, Globe, Award, User, Code2, Users, Search, Settings, Rocket,
  Container, Anchor, Truck
} from 'lucide-react';

// --- DATA & TRANSLATIONS ---

const translations = {
  vi: {
    common: {
      consult_now: "Tư vấn ngay",
      problem: "Vấn đề & Nỗi đau:",
      solution: "Giải pháp Đột phá:",
      result: "Kết quả thực tế:",
      tags: "Công nghệ:"
    },
    nav: {
      about: "Chuyên Gia & Teams",
      services: "Giải Pháp",
      projects: "Câu Chuyện Thành Công",
      haiphong: "TT Hải Phòng", 
      process: "Quy Trình",
      contact_menu: "Liên Hệ",
      quote: "Liên Hệ Báo Giá"
    },
    hero: {
      badge: "Giải pháp số hóa chuẩn Đức",
      title_prefix: "Biến Dữ Liệu Thành",
      title_highlight: "Sức Mạnh Cạnh Tranh",
      desc: "Mang tư duy kỹ thuật chính xác của Đức và kinh nghiệm thực chiến tại các tập đoàn đa quốc gia về Việt Nam. Chúng tôi không chỉ cung cấp công cụ, mà kiến tạo nền tảng dữ liệu thông minh giúp doanh nghiệp tối ưu vận hành, dự báo rủi ro và tự động hóa quy trình để bứt phá doanh thu trên thị trường toàn cầu.",
      btn_primary: "Khám Phá Giải Pháp",
      btn_secondary: "Hồ Sơ Năng Lực"
    },
    about: {
      subtitle: "Hành Trình & Con Người",
      title: "Chuyên Gia Phu Viet & Đội Ngũ (Teams)",
      role: "Senior Data Engineer & AI Solution Architect",
      exp: "10+ Năm Chinh Chiến Tại Thị Trường Đức",
      intro: "Câu chuyện của chúng tôi",
      story: "Hành trình bắt đầu tại Đức - cái nôi của công nghiệp 4.0. Từ việc trực tiếp kiến tạo giải pháp Big Data giúp nhà máy đạt giải thưởng Smart Factory danh giá, tôi nhận thấy sức mạnh to lớn của dữ liệu khi được áp dụng đúng cách. Trở về với khát vọng nâng tầm doanh nghiệp Việt, tôi không làm việc một mình.",
      team_intro: "Bên cạnh chuyên gia là một Đội ngũ (Teams) thiện chiến, kết hợp giữa tư duy chiến lược quốc tế và năng lực thực thi tốc độ. Các thành viên đều dày dặn kinh nghiệm triển khai thực tế, hiểu rõ không chỉ về Code mà còn về Business Logic (Nghiệp vụ kinh doanh).",
      points: [
        { title: "Dấu ấn Quốc Tế", desc: "Lãnh đạo đổi mới sáng tạo, phát triển giải pháp Big Data thời gian thực, đóng vai trò then chốt giúp khách hàng thắng giải Smart Factory 4.0 tại Đức." },
        { title: "Tiên phong về AI", desc: "Đạt giải Ba cuộc thi AI doanh nghiệp tại Châu Âu nhờ giải pháp ứng dụng trí tuệ nhân tạo vào tối ưu hóa vận hành thực tiễn." },
        { title: "Thực chiến & Hiệu quả", desc: "Hơn một thập kỷ tư vấn và triển khai hạ tầng dữ liệu cho các tập đoàn lớn (Enterprise), đảm bảo hệ thống chịu tải cao và bảo mật." },
        { title: "Kết nối Đa văn hóa", desc: "Thành thạo tiếng Đức, Anh, Việt. Cầu nối hoàn hảo cho các dự án Outsourcing hoặc doanh nghiệp FDI tại Việt Nam." }
      ],
      tech_title: "Năng Lực Kỹ Thuật",
      tech_groups: {
        warehouse: "Data Warehouse & Kiến trúc",
        db: "Cơ sở dữ liệu & Cloud",
        etl: "Tích hợp & Migration",
        bi: "Business Intelligence (BI)",
        auto: "Tự động hóa & AI"
      }
    },
    services: {
      subtitle: "Giải Pháp Toàn Diện",
      title: "Hệ Sinh Thái Dữ Liệu & Tự Động Hóa",
      items: [
        { 
          title: "Reporting & BI Dashboard Chiến Lược", 
          desc: "Chúng tôi không chỉ vẽ biểu đồ, chúng tôi kể câu chuyện về sức khỏe doanh nghiệp. Hệ thống Dashboard được thiết kế theo tư duy quản trị chuẩn quốc tế (IBCS), giúp Ban lãnh đạo nhìn thấu toàn cảnh bức tranh tài chính và vận hành.",
          details: ["Trực quan hóa dữ liệu Real-time trên Power BI / Tableau / Metabase.", "Phân tích chuyên sâu (Drill-down) từ tổng quan đến chi tiết từng mã hàng/nhân sự.", "Tích hợp cảnh báo rủi ro tự động khi chỉ số vượt ngưỡng an toàn.", "Truy cập báo cáo mọi lúc mọi nơi trên thiết bị di động (Mobile App)."]
        },
        { 
          title: "Data Warehouse: Trái Tim Dữ Liệu", 
          desc: "Xây dựng nền tảng dữ liệu tập trung (Single Source of Truth) vững chắc. Chúng tôi giải quyết bài toán dữ liệu phân tán, rời rạc từ ERP, CRM, Excel rác để tạo ra nguồn dữ liệu sạch - đúng - đủ.",
          details: ["Thiết kế kiến trúc Data Vault 2.0 / 3NF / Star Schema chuẩn Enterprise.", "Quy trình ETL/ELT tự động làm sạch và chuẩn hóa dữ liệu thô.", "Bảo mật phân quyền dữ liệu theo cấp bậc (Row-level Security).", "Lưu trữ lịch sử biến động dữ liệu để phục vụ kiểm toán và dự báo."]
        },
        { 
          title: "Tự Động Hóa Quy Trình (Automation)", 
          desc: "Tối ưu hóa nguồn lực nhân sự bằng công nghệ. Chúng tôi chuyển đổi các quy trình thủ công, lặp lại nhàm chán thành các luồng làm việc tự động thông minh, hoạt động 24/7 không biết mệt mỏi.",
          details: ["Tự động hóa luồng công việc (Workflow) phức tạp với n8n, Airflow, Python.", "Kết nối API giữa các hệ thống rời rạc (KiotViet, Misa, CRM, Excel...).", "Tự động gửi báo cáo, hóa đơn, email chăm sóc khách hàng.", "Giảm thiểu 99% lỗi sai sót do con người (Human Error) trong nhập liệu."]
        }
      ]
    },
    haiphong: {
      subtitle: "Thị Trường Trọng Điểm",
      title: "Giải Pháp Đặc Thù Cho Hải Phòng",
      desc: "Hải Phòng là cửa ngõ ra biển lớn, trung tâm công nghiệp và logistics sôi động nhất miền Bắc. Hiểu rõ đặc thù địa phương, chúng tôi thiết kế các giải pháp chuyên biệt để giúp doanh nghiệp Hải Phòng tối ưu hóa thế mạnh này.",
      solutions: [
        {
          title: "Smart Logistics & Port Management",
          desc: "Tối ưu hóa luồng vận tải và quản lý kho bãi cảng biển, giảm thời gian chờ và chi phí lưu kho.",
          features: ["Tracking Container Real-time", "Tự động hóa chứng từ XNK (OCR)", "Dự báo tắc nghẽn cảng bằng AI"]
        },
        {
          title: "Sản Xuất Tại KCN (IZ)",
          desc: "Giải pháp Smart Factory toàn diện cho các nhà máy tại KCN Tràng Duệ, VSIP, Nomura...",
          features: ["Giám sát hiệu suất (OEE) dây chuyền", "Bảo trì tiên đoán (Predictive Maintenance)", "Kho dữ liệu sản xuất tập trung"]
        }
      ]
    },
    process: {
      subtitle: "Làm Việc Chuyên Nghiệp",
      title: "Quy Trình Chuẩn 4 Bước",
      steps: [
        { number: "01", title: "Khảo Sát & Tư Vấn", desc: "Đánh giá hiện trạng dữ liệu và nhu cầu doanh nghiệp. Xác định rõ bài toán cần giải." },
        { number: "02", title: "Thiết Kế Kiến Trúc", desc: "Xây dựng mô hình Data Warehouse và luồng dữ liệu (Data Flow) tối ưu nhất." },
        { number: "03", title: "Phát Triển (Agile)", desc: "Triển khai từng giai đoạn (Sprints), đảm bảo sản phẩm dùng được ngay và dễ điều chỉnh." },
        { number: "04", title: "Đào Tạo & Bàn Giao", desc: "Hướng dẫn nhân sự sử dụng hệ thống và chuyển giao toàn bộ tài liệu kỹ thuật." }
      ]
    },
    casestudies: {
      subtitle: "Thực Tế Triển Khai",
      title: "Câu Chuyện Thành Công",
      items: [
        {
          title: "Cứu Nhà Máy Khỏi 20% Phế Phẩm",
          industry: "Sản Xuất Tự Động Hóa",
          problem: "Trong dây chuyền sản xuất áp lực cao, việc phát hiện lỗi sản phẩm bị chậm trễ khiến nhà máy lãng phí hàng tấn nguyên liệu mỗi tháng. Quản lý sản xuất như 'người mù' vì báo cáo chất lượng luôn trễ 2 ngày.",
          solution: "Chúng tôi triển khai hệ thống 'Digital Quality Guard'. Dữ liệu từ cảm biến máy móc được đẩy thẳng lên Dashboard theo thời gian thực (Real-time). Bất kỳ chỉ số nhiệt/áp suất nào lệch chuẩn, hệ thống tự động gửi tin nhắn cảnh báo ngay lập tức cho kỹ sư trưởng.",
          result: "Cắt giảm 20% tỷ lệ hàng lỗi ngay trong tháng đầu tiên. Đội ngũ kỹ thuật chuyển từ trạng thái 'đi dập lửa' sang 'phòng ngừa rủi ro' chủ động.",
          tags: ["Real-time Dashboard", "Alert Automation", "Quality Control", "Power BI"]
        },
        {
          title: "Giải Phóng 150 Giờ Cho Kế Toán",
          industry: "Bán Lẻ & Kế Toán",
          problem: "Mỗi cuối tháng là cơn ác mộng của phòng kế toán: phải tổng hợp thủ công 14 file Excel từ 14 cửa hàng với định dạng lộn xộn. Sai sót số liệu xảy ra cơm bữa, và CEO không bao giờ biết chính xác doanh thu cho đến ngày 10 tháng sau.",
          solution: "Chúng tôi xóa bỏ quy trình thủ công bằng một 'Đường ống dữ liệu' (Data Pipeline) tự động. Hệ thống tự động 'hút' dữ liệu từ các máy POS cửa hàng, làm sạch, chuẩn hóa và đổ về kho dữ liệu trung tâm mỗi đêm. Báo cáo tài chính tự động cập nhật vào 8h sáng hôm sau.",
          result: "Tiết kiệm 150 giờ làm việc/tháng (gần như trọn vẹn 1 nhân sự). Báo cáo chính xác 100%, CEO nắm bắt dòng tiền hàng ngày trên điện thoại.",
          tags: ["PostgreSQL", "ETL Pipeline", "Finance DB", "Automation"]
        },
        {
          title: "AI 'Đọc' Hợp Đồng Thay Luật Sư",
          industry: "Pháp Chế & Admin",
          problem: "Bộ phận pháp chế quá tải với hàng nghìn hợp đồng giấy tờ cần rà soát mỗi năm. Việc tra cứu lại một điều khoản trong kho lưu trữ vật lý tốn hàng giờ đồng hồ và rủi ro bỏ sót các điều khoản bất lợi là rất cao.",
          solution: "Triển khai giải pháp 'AI Legal Assistant' chạy trên máy chủ nội bộ (bảo mật tuyệt đối). Sử dụng công nghệ OCR và LLM (Ollama) để số hóa toàn bộ văn bản giấy. Nhân viên chỉ cần gõ câu hỏi bằng ngôn ngữ tự nhiên, AI sẽ trích xuất câu trả lời từ hợp đồng trong 2 giây.",
          result: "Giảm 80% thời gian tra cứu hồ sơ. Hệ thống tự động cảnh báo các điều khoản hết hạn, giúp doanh nghiệp tránh được các rủi ro pháp lý trị giá hàng tỷ đồng.",
          tags: ["Local Host AI", "Ollama", "n8n", "OCR", "Doc Automation"]
        }
      ]
    },
    contact: {
      title: "Liên hệ tư vấn chiến lược",
      desc: "Đừng để dữ liệu ngủ quên. Hãy để chúng tôi đánh thức tiềm năng doanh nghiệp của bạn.",
      office: "Văn phòng",
      form: { name: "Họ và tên", phone: "Số điện thoại / Zalo", company: "Công ty", needs: "Vấn đề đang gặp phải", btn: "Đăng Ký Tư Vấn Miễn Phí" }
    }
  },
  en: {
    common: {
      consult_now: "Consult Now",
      problem: "Problem & Pain Point:",
      solution: "Breakthrough Solution:",
      result: "Real Result:",
      tags: "Tech Stack:"
    },
    nav: {
      about: "Expert & Teams",
      services: "Solutions",
      projects: "Success Stories",
      haiphong: "Hai Phong Market",
      process: "Process",
      contact_menu: "Contact",
      quote: "Get Quote"
    },
    hero: {
      badge: "German Standard Digital Solutions",
      title_prefix: "Turning Data Into",
      title_highlight: "Competitive Advantage",
      desc: "Bringing German engineering precision and global corporate experience to Vietnam. We don't just provide tools; we build intelligent data foundations helping businesses optimize operations, forecast risks, and automate processes for global revenue breakthroughs.",
      btn_primary: "Explore Solutions",
      btn_secondary: "View Portfolio"
    },
    about: {
      subtitle: "Journey & People",
      title: "Expert Phu Viet & Teams",
      role: "Senior Data Engineer & AI Solution Architect",
      exp: "10+ Years Experience in Germany",
      intro: "Our Story",
      story: "The journey began in Germany - the cradle of Industry 4.0. From architecting Big Data solutions that won the prestigious Smart Factory Award, I realized the immense power of data. Returning with a vision to elevate businesses, I don't work alone.",
      team_intro: "Alongside the expert is a combat-ready Team, combining international strategic thinking with high-speed execution. Members are experienced in real-world deployment, understanding not just Code but Business Logic.",
      points: [
        { title: "International Mark", desc: "Innovation leader, developed Real-time Big Data solutions pivotal to winning the Smart Factory 4.0 Award in Germany." },
        { title: "AI Pioneer", desc: "3rd Prize in Corporate AI Competition in Europe for applying AI to practical operational optimization." },
        { title: "Proven Efficacy", desc: "Over a decade of consulting and deploying data infrastructure for Enterprises, ensuring high load capacity and security." },
        { title: "Cross-cultural Connect", desc: "Fluent in German, English, Vietnamese. Perfect bridge for Outsourcing projects or FDI companies." }
      ],
      tech_title: "Technical Competence",
      tech_groups: {
        warehouse: "Data Warehouse & Architecture",
        db: "Databases & Cloud",
        etl: "Integration & Migration",
        bi: "Business Intelligence (BI)",
        auto: "Automation & AI"
      }
    },
    services: {
      subtitle: "Comprehensive Solutions",
      title: "Data & Automation Ecosystem",
      items: [
        { title: "Strategic Reporting & BI Dashboard", desc: "We don't just draw charts; we tell stories about business health. Dashboard systems designed to IBCS standards help Management see the full financial and operational picture.", details: ["Real-time Visualization on Power BI / Tableau.", "Deep Drill-down analysis.", "Auto Alerts for risks.", "Mobile App Access."] },
        { title: "Data Warehouse", desc: "Building a solid Single Source of Truth. We solve the problem of scattered data from ERP, CRM, and Excel files to create a clean, correct, and sufficient data source.", details: ["Data Vault 2.0 / Star Schema Architecture.", "Automated ETL/ELT Pipelines.", "Row-level Security.", "Historical Tracking."] },
        { title: "Process Automation", desc: "Optimizing human resources with technology. We convert boring, repetitive manual processes into intelligent automated workflows running 24/7.", details: ["Complex Workflows with n8n, Python.", "API Integration (KiotViet, CRM...).", "Automated Reporting.", "Reduce 99% of Human Errors."] }
      ]
    },
    haiphong: {
      subtitle: "Key Market",
      title: "Specialized Solutions for Hai Phong",
      desc: "Hai Phong is the gateway to the sea and the most vibrant industrial and logistics hub in the North. Understanding local specifics, we design specialized solutions to help Hai Phong businesses optimize these strengths.",
      solutions: [
        {
          title: "Smart Logistics & Port Management",
          desc: "Optimizing transport flows and port warehouse management, reducing waiting times and storage costs.",
          features: ["Real-time Container Tracking", "Automated Import/Export Docs (OCR)", "AI Congestion Forecasting"]
        },
        {
          title: "Industrial Zone Production (IZ)",
          desc: "Comprehensive Smart Factory solutions for factories in Trang Due, VSIP, Nomura Industrial Zones...",
          features: ["OEE Line Monitoring", "Predictive Maintenance", "Centralized Production Data Warehouse"]
        }
      ]
    },
    process: {
      subtitle: "Professional Workflow",
      title: "Standard 4-Step Process",
      steps: [
        { number: "01", title: "Survey & Consulting", desc: "Assess data status and business needs. Define the problem clearly." },
        { number: "02", title: "Architecture Design", desc: "Build Data Warehouse model and optimal Data Flow." },
        { number: "03", title: "Development (Agile)", desc: "Deploy in Sprints, ensuring usable products and easy adjustments." },
        { number: "04", title: "Training & Handover", desc: "Guide staff on system usage and handover all technical documentation." }
      ]
    },
    casestudies: {
      subtitle: "Real Implementation",
      title: "Success Stories",
      items: [
        {
          title: "Saving Factory from 20% Waste",
          industry: "Manufacturing Automation",
          problem: "In high-pressure production lines, delayed error detection caused the factory to waste tons of materials monthly. Production management was 'blind' because quality reports were always 2 days late.",
          solution: "We deployed the 'Digital Quality Guard' system. Data from machine sensors is pushed directly to the Dashboard in Real-time. Any deviation in heat/pressure automatically triggers instant alerts to the chief engineer.",
          result: "Reduced defect rate by 20% in the first month. Technical team shifted from 'firefighting' to proactive 'risk prevention'.",
          tags: ["Real-time Dashboard", "Alert Automation", "Quality Control", "Power BI"]
        },
        {
          title: "Freeing 150 Hours for Accountants",
          industry: "Retail & Finance",
          problem: "Month-end was a nightmare for the accounting department: manually merging 14 Excel files from 14 stores with messy formats. Data errors were frequent, and the CEO never knew exact revenue until the 10th of the next month.",
          solution: "We eliminated the manual process with an Automated Data Pipeline. The system automatically 'sucks' data from store POS, cleans, normalizes, and pours it into the central data warehouse every night. Financial reports update automatically by 8 AM.",
          result: "Saved 150 work hours/month (almost one full staff member). 100% accuracy. CEO tracks cash flow daily on mobile.",
          tags: ["PostgreSQL", "ETL Pipeline", "Finance DB", "Automation"]
        },
        {
          title: "AI Reads Contracts Instead of Lawyers",
          industry: "Legal & Admin",
          problem: "The legal department was overloaded with thousands of paper contracts to review annually. Looking up a clause in physical storage took hours, and the risk of missing disadvantageous terms was very high.",
          solution: "Deployed 'AI Legal Assistant' solution running on a local server (absolute security). Using OCR and LLM (Ollama) technology to digitize all paper documents. Staff simply type questions in natural language, and AI extracts answers from contracts in 2 seconds.",
          result: "Reduced search time by 80%. The system automatically warns of expiring terms, helping the business avoid legal risks worth billions.",
          tags: ["Local Host AI", "Ollama", "n8n", "OCR", "Doc Automation"]
        }
      ]
    },
    contact: {
      title: "Contact for Strategic Consulting",
      desc: "Don't let your data sleep. Let us awaken your business potential.",
      office: "Office",
      form: { name: "Full Name", phone: "Phone / WhatsApp", company: "Company", needs: "Current Challenges", btn: "Free Consultation Signup" }
    }
  },
  ko: {
    common: {
      consult_now: "지금 상담하기",
      problem: "문제점:",
      solution: "해결책:",
      result: "결과:",
      tags: "기술 스택:"
    },
    nav: {
      about: "전문가 및 팀",
      services: "솔루션",
      projects: "성공 사례",
      haiphong: "하이퐁 시장",
      process: "프로세스",
      contact_menu: "연락처",
      quote: "견적 요청"
    },
    hero: {
      badge: "독일 표준 디지털 솔루션",
      title_prefix: "데이터를",
      title_highlight: "경쟁 우위로 전환",
      desc: "독일 엔지니어링의 정밀함과 글로벌 기업 경험을 베트남에 가져옵니다. 우리는 단순히 도구만 제공하는 것이 아니라, 기업이 운영을 최적화하고 리스크를 예측하며 프로세스를 자동화하여 글로벌 시장에서 매출을 획기적으로 증대할 수 있도록 돕는 지능형 데이터 기반을 구축합니다.",
      btn_primary: "솔루션 보기",
      btn_secondary: "포트폴리오"
    },
    about: {
      subtitle: "여정 및 사람들",
      title: "Phu Viet 전문가 & 팀",
      role: "수석 데이터 엔지니어 & AI 솔루션 아키텍트",
      exp: "10년 이상의 독일 현지 경험",
      intro: "우리의 이야기",
      story: "이 여정은 인더스트리 4.0의 발상지인 독일에서 시작되었습니다. 권위 있는 스마트 팩토리 어워드를 수상한 공장의 빅데이터 솔루션을 직접 설계하면서, 저는 데이터가 올바르게 적용되었을 때의 막대한 힘을 깨달았습니다. 베트남 기업의 수준을 높이겠다는 비전을 가지고 돌아온 저는 혼자가 아닙니다.",
      team_intro: "전문가와 함께하는 것은 국제적인 전략적 사고와 빠른 실행력을 겸비한 전투적인 팀입니다. 팀원들은 실제 구축 경험이 풍부하며, 단순히 코드뿐만 아니라 비즈니스 로직(Business Logic)을 깊이 이해하고 있습니다.",
      points: [
        { title: "국제적 성과", desc: "혁신 리더로서 실시간 빅데이터 솔루션을 개발하여 독일 Smart Factory 4.0 어워드 수상에 결정적인 역할을 했습니다." },
        { title: "AI 개척자", desc: "AI를 실제 운영 최적화에 적용한 솔루션으로 유럽 기업 AI 대회에서 3위를 수상했습니다." },
        { title: "검증된 효율성", desc: "10년 이상 대기업(Enterprise)을 위한 데이터 인프라를 컨설팅하고 구축하며, 높은 부하 처리 능력과 보안을 보장해 왔습니다." },
        { title: "다문화 연결", desc: "독일어, 영어, 베트남어에 능통합니다. 아웃소싱 프로젝트나 베트남 내 FDI 기업을 위한 완벽한 가교 역할을 합니다." }
      ],
      tech_title: "기술 역량",
      tech_groups: {
        warehouse: "데이터 웨어하우스 & 아키텍처",
        db: "데이터베이스 & 클라우드",
        etl: "통합 & 마이그레이션",
        bi: "비즈니스 인텔리전스 (BI)",
        auto: "자동화 & AI"
      }
    },
    services: {
      subtitle: "포괄적인 솔루션",
      title: "데이터 & 자동화 생태계",
      items: [
        { title: "전략적 리포팅 & BI 대시보드", desc: "우리는 단순히 차트를 그리는 것이 아니라, 기업의 건강 상태에 대한 이야기를 전달합니다. 국제 경영 표준(IBCS)에 따라 설계된 대시보드 시스템은 경영진이 재무 및 운영의 전체 그림을 명확하게 볼 수 있도록 돕습니다.", details: ["Power BI / Tableau / Metabase에서 실시간 데이터 시각화.", "개요부터 세부 항목/인력까지 심층 분석(Drill-down).", "지표가 안전 임계값을 초과할 경우 자동 리스크 경고.", "모바일 앱을 통해 언제 어디서나 보고서 접속."] },
        { title: "데이터 웨어하우스: 데이터의 심장", desc: "견고한 중앙 집중식 데이터 플랫폼(Single Source of Truth)을 구축합니다. ERP, CRM, 엑셀 파일 등에 흩어져 있는 데이터 문제를 해결하여 깨끗하고 정확하며 충분한 데이터 소스를 생성합니다.", details: ["엔터프라이즈 표준 Data Vault 2.0 / 3NF / Star Schema 아키텍처 설계.", "원시 데이터를 자동으로 정제하고 표준화하는 ETL/ELT 프로세스.", "직급에 따른 행 수준 보안(Row-level Security).", "감사 및 예측을 위한 데이터 변동 이력 저장."] },
        { title: "프로세스 자동화 (Automation)", desc: "기술을 통한 인적 자원 최적화. 지루하고 반복적인 수동 프로세스를 24시간 365일 지치지 않고 작동하는 지능형 자동 워크플로우로 전환합니다.", details: ["n8n, Airflow, Python을 이용한 복잡한 업무 흐름(Workflow) 자동화.", "분리된 시스템 간 API 연결 (KiotViet, Misa, CRM, Excel...).", "보고서, 청구서, 고객 관리 이메일 자동 발송.", "데이터 입력 시 발생하는 인적 오류(Human Error) 99% 감소."] }
      ]
    },
    haiphong: {
      subtitle: "핵심 시장",
      title: "하이퐁(Hai Phong) 특화 솔루션",
      desc: "하이퐁은 바다로 향하는 관문이자 북부에서 가장 활발한 산업 및 물류 허브입니다. 우리는 현지의 특수성을 깊이 이해하고 있으며, 하이퐁 기업들이 이러한 강점을 최적화할 수 있도록 특화된 솔루션을 설계합니다.",
      solutions: [
        {
          title: "스마트 물류 & 항만 관리",
          desc: "운송 흐름 및 항만 창고 관리를 최적화하여 대기 시간과 보관 비용을 절감합니다.",
          features: ["실시간 컨테이너 추적", "수출입 문서 자동화 (OCR)", "AI를 이용한 항만 혼잡 예측"]
        },
        {
          title: "산업단지(IZ) 생산 관리",
          desc: "Trang Due, VSIP, Nomura 등 산업단지 내 공장을 위한 포괄적인 스마트 팩토리 솔루션.",
          features: ["생산 라인 효율(OEE) 모니터링", "예지 보전 (Predictive Maintenance)", "중앙 집중식 생산 데이터 웨어하우스"]
        }
      ]
    },
    process: {
      subtitle: "전문 작업 방식",
      title: "표준 4단계 프로세스",
      steps: [
        { number: "01", title: "조사 및 컨설팅", desc: "데이터 현황 및 기업의 요구사항을 평가합니다. 해결해야 할 문제를 명확히 정의합니다." },
        { number: "02", title: "아키텍처 설계", desc: "데이터 웨어하우스 모델과 최적의 데이터 흐름(Data Flow)을 구축합니다." },
        { number: "03", title: "개발 (Agile)", desc: "각 단계(Sprint)별로 배포하여 즉시 사용 가능한 제품을 제공하고 수정이 용이하게 합니다." },
        { number: "04", title: "교육 및 인계", desc: "직원들에게 시스템 사용법을 안내하고 모든 기술 문서를 이관합니다." }
      ]
    },
    casestudies: {
      subtitle: "실제 구현",
      title: "성공 사례",
      items: [
        {
          title: "공장을 20%의 불량품 낭비에서 구하다",
          industry: "자동화 제조",
          problem: "압박이 심한 생산 라인에서 제품 오류 발견이 지연되어 공장은 매달 수 톤의 원자재를 낭비하고 있었습니다. 품질 보고서가 항상 2일 늦게 나오기 때문에 생산 관리자는 마치 '장님'과 같았습니다.",
          solution: "'디지털 품질 가드(Digital Quality Guard)' 시스템을 구축했습니다. 기계 센서 데이터가 실시간으로 대시보드에 전송됩니다. 온도/압력 지표가 표준을 벗어나는 즉시 시스템이 수석 엔지니어에게 자동으로 경고 메시지를 보냅니다.",
          result: "첫 달에 불량률을 20% 줄였습니다. 기술팀은 '화재 진압' 상태에서 주도적인 '리스크 예방' 상태로 전환했습니다.",
          tags: ["Real-time Dashboard", "Alert Automation", "Quality Control", "Power BI"]
        },
        {
          title: "회계팀에 150시간을 돌려주다",
          industry: "소매 & 금융",
          problem: "매달 말은 회계팀의 악몽이었습니다. 14개 매장에서 보내온 형식이 엉망인 14개의 엑셀 파일을 수동으로 취합해야 했습니다. 데이터 오류는 밥 먹듯이 발생했고, CEO는 다음 달 10일이 될 때까지 정확한 매출을 알 수 없었습니다.",
          solution: "자동화된 '데이터 파이프라인(Data Pipeline)'으로 수동 프로세스를 제거했습니다. 시스템은 매장 POS에서 데이터를 자동으로 '흡입'하여 정제 및 표준화한 후 매일 밤 중앙 데이터 창고로 전송합니다. 재무 보고서는 다음 날 아침 8시에 자동 업데이트됩니다.",
          result: "월 150시간의 업무 시간을 절약했습니다(거의 직원 1명 분량). 정확도 100%, CEO는 매일 모바일로 현금 흐름을 파악합니다.",
          tags: ["PostgreSQL", "ETL Pipeline", "Finance DB", "Automation"]
        },
        {
          title: "변호사 대신 계약서를 읽는 AI",
          industry: "법무 & 관리",
          problem: "법무팀은 매년 검토해야 할 수천 건의 종이 계약서로 과부하 상태였습니다. 물리적 보관소에서 조항 하나를 찾는 데 몇 시간이 걸렸고, 불리한 조항을 놓칠 위험이 매우 높았습니다.",
          solution: "로컬 서버에서 실행되는(절대 보안) 'AI 법률 비서' 솔루션을 구축했습니다. OCR 및 LLM(Ollama) 기술을 사용하여 모든 종이 문서를 디지털화했습니다. 직원이 자연어로 질문을 입력하면 AI가 2초 만에 계약서에서 답변을 추출합니다.",
          result: "문서 검색 시간을 80% 단축했습니다. 시스템이 만료되는 조항을 자동으로 경고하여 기업이 수십억 동의 법적 리스크를 피할 수 있도록 돕습니다.",
          tags: ["Local Host AI", "Ollama", "n8n", "OCR", "Doc Automation"]
        }
      ]
    },
    contact: {
      title: "전략 컨설팅 문의",
      desc: "데이터를 잠재우지 마십시오. 우리가 당신의 비즈니스 잠재력을 깨우겠습니다.",
      office: "사무실",
      form: { name: "이름", phone: "전화번호 / Zalo", company: "회사", needs: "직면한 문제", btn: "무료 상담 신청" }
    }
  },
  de: {
    common: {
      consult_now: "Jetzt beraten lassen",
      problem: "Problem:",
      solution: "Lösung:",
      result: "Ergebnis:",
      tags: "Tech Stack:"
    },
    nav: {
      about: "Experte & Teams",
      services: "Lösungen",
      projects: "Erfolgsgeschichten",
      haiphong: "Markt Hai Phong",
      process: "Prozess",
      contact_menu: "Kontakt",
      quote: "Angebot Anfordern"
    },
    hero: {
      badge: "Digitale Lösungen nach deutschem Standard",
      title_prefix: "Daten in",
      title_highlight: "Wettbewerbsvorteile verwandeln",
      desc: "Wir bringen deutsche Ingenieurspräzision und globale Konzernerfahrung nach Vietnam. Wir bieten nicht nur Werkzeuge, sondern bauen intelligente Datenfundamente, die Unternehmen helfen, den Betrieb zu optimieren, Risiken vorherzusagen und Prozesse zu automatisieren, um auf dem globalen Markt Umsatzdurchbrüche zu erzielen.",
      btn_primary: "Lösungen Entdecken",
      btn_secondary: "Portfolio Ansehen"
    },
    about: {
      subtitle: "Reise & Menschen",
      title: "Experte Phu Viet & Teams",
      role: "Senior Data Engineer & AI Solution Architect",
      exp: "10+ Jahre Erfahrung in Deutschland",
      intro: "Unsere Geschichte",
      story: "Die Reise begann in Deutschland – der Wiege der Industrie 4.0. Durch die direkte Entwicklung von Big-Data-Lösungen, die einer Fabrik halfen, den prestigeträchtigen Smart Factory Award zu gewinnen, erkannte ich die immense Macht von Daten, wenn sie richtig angewendet werden. Zurückgekehrt mit dem Bestreben, vietnamesische Unternehmen voranzubringen, arbeite ich nicht allein.",
      team_intro: "An der Seite des Experten steht ein kampferprobtes Team, das internationale Strategie mit schneller Umsetzungskompetenz verbindet. Alle Mitglieder verfügen über umfangreiche Erfahrung in der praktischen Umsetzung und verstehen nicht nur Code, sondern auch Business Logic.",
      points: [
        { title: "Internationaler Erfolg", desc: "Innovationsführer bei der Entwicklung von Echtzeit-Big-Data-Lösungen, die eine Schlüsselrolle beim Gewinn des Smart Factory 4.0 Preises in Deutschland spielten." },
        { title: "KI-Pionier", desc: "3. Platz beim KI-Wettbewerb für Unternehmen in Europa dank einer Lösung zur Anwendung künstlicher Intelligenz zur praktischen Betriebsoptimierung." },
        { title: "Nachgewiesene Effizienz", desc: "Über ein Jahrzehnt Erfahrung in der Beratung und Implementierung von Dateninfrastrukturen für Großkonzerne (Enterprise), wobei hohe Belastbarkeit und Sicherheit gewährleistet wurden." },
        { title: "Interkulturelle Brücke", desc: "Fließend in Deutsch, Englisch, Vietnamesisch. Die perfekte Brücke für Outsourcing-Projekte oder FDI-Unternehmen in Vietnam." }
      ],
      tech_title: "Technische Kompetenz",
      tech_groups: {
        warehouse: "Data Warehouse & Architektur",
        db: "Datenbanktechnologien & Cloud",
        etl: "Integration & Migration",
        bi: "Business Intelligence (BI)",
        auto: "Automatisierung & KI"
      }
    },
    services: {
      subtitle: "Umfassende Lösungen",
      title: "Daten- & Automatisierungs-Ökosystem",
      items: [
        { title: "Strategisches Reporting & BI Dashboard", desc: "Wir zeichnen nicht nur Diagramme, wir erzählen die Geschichte der Unternehmensgesundheit. Dashboard-Systeme, die nach internationalen Managementstandards (IBCS) entwickelt wurden, helfen der Geschäftsführung, das gesamte finanzielle und operative Bild zu durchschauen.", details: ["Echtzeit-Visualisierung von Daten auf Power BI / Tableau / Metabase.", "Tiefenanalyse (Drill-down) von der Übersicht bis zu Details.", "Integrierte automatische Risikowarnungen.", "Zugriff auf Berichte jederzeit und überall über mobile Geräte."] },
        { title: "Data Warehouse: Das Herz der Daten", desc: "Aufbau einer soliden zentralen Datenplattform (Single Source of Truth). Wir lösen das Problem verstreuter Daten aus ERP, CRM und Excel-Dateien, um eine saubere, korrekte und ausreichende Datenquelle zu schaffen.", details: ["Design der Data Vault 2.0 / 3NF / Star Schema Architektur nach Enterprise-Standard.", "Automatisierte ETL/ELT-Prozesse zur Bereinigung und Standardisierung von Rohdaten.", "Datensicherheit auf Zeilenebene (Row-level Security).", "Speicherung der Datenhistorie für Audits und Prognosen."] },
        { title: "Prozessautomatisierung (Automation)", desc: "Optimierung der Personalressourcen durch Technologie. Wir wandeln langweilige, repetitive manuelle Prozesse in intelligente automatische Arbeitsabläufe um, die rund um die Uhr unermüdlich arbeiten.", details: ["Automatisierung komplexer Arbeitsabläufe (Workflow) mit n8n, Airflow, Python.", "API-Verbindung zwischen getrennten Systemen (KiotViet, Misa, CRM...).", "Automatischer Versand von Berichten, Rechnungen, E-Mails.", "Reduzierung menschlicher Fehler (Human Error) bei der Dateneingabe um 99%."] }
      ]
    },
    haiphong: {
      subtitle: "Schlüsselmarkt",
      title: "Spezialisierte Lösungen für Hai Phong",
      desc: "Hai Phong ist das Tor zum Meer und das lebendigste Industrie- und Logistikzentrum im Norden. Wir verstehen die lokalen Besonderheiten und entwickeln spezialisierte Lösungen, um Unternehmen in Hai Phong zu helfen, diese Stärken zu optimieren.",
      solutions: [
        {
          title: "Smart Logistics & Hafenmanagement",
          desc: "Optimierung von Transportströmen und Hafenlagerverwaltung, Reduzierung von Wartezeiten und Lagerkosten.",
          features: ["Echtzeit-Container-Tracking", "Automatisierung von Import/Export-Dokumenten (OCR)", "KI-basierte Stauprognose"]
        },
        {
          title: "Produktion in Industriezonen (IZ)",
          desc: "Umfassende Smart Factory Lösungen für Fabriken in den Industriezonen Trang Due, VSIP, Nomura...",
          features: ["Überwachung der Anlageneffektivität (OEE)", "Vorausschauende Wartung (Predictive Maintenance)", "Zentrales Produktions-Data-Warehouse"]
        }
      ]
    },
    process: {
      subtitle: "Professionelle Arbeitsweise",
      title: "Standard 4-Schritte-Prozess",
      steps: [
        { number: "01", title: "Aufnahme & Beratung", desc: "Bewertung des aktuellen Datenstatus und der Unternehmensanforderungen. Klare Definition des zu lösenden Problems." },
        { number: "02", title: "Architekturdesign", desc: "Aufbau des Data Warehouse-Modells und der optimalen Datenflüsse (Data Flow)." },
        { number: "03", title: "Entwicklung (Agile)", desc: "Implementierung in Phasen (Sprints), um sicherzustellen, dass das Produkt sofort nutzbar und leicht anpassbar ist." },
        { number: "04", title: "Schulung & Übergabe", desc: "Anleitung des Personals zur Nutzung des Systems und Übergabe der gesamten technischen Dokumentation." }
      ]
    },
    casestudies: {
      subtitle: "Praxisnahe Umsetzung",
      title: "Erfolgsgeschichten",
      items: [
        {
          title: "Fabrik vor 20% Ausschuss gerettet",
          industry: "Automatisierte Produktion",
          problem: "In Produktionslinien mit hohem Druck führte die verzögerte Fehlererkennung dazu, dass die Fabrik jeden Monat tonnenweise Material verschwendete. Der Produktionsleiter war 'blind', weil Qualitätsberichte immer 2 Tage zu spät kamen.",
          solution: "Wir implementierten das 'Digital Quality Guard' System. Daten von Maschinensensoren werden in Echtzeit auf das Dashboard übertragen. Jede Abweichung bei Temperatur/Druck löst sofort eine automatische Warnmeldung an den Chefingenieur aus.",
          result: "Senkung der Fehlerrate um 20% im ersten Monat. Das technische Team wechselte vom 'Feuerlösch'-Modus zur proaktiven 'Risikoprävention'.",
          tags: ["Real-time Dashboard", "Alert Automation", "Quality Control", "Power BI"]
        },
        {
          title: "150 Stunden für die Buchhaltung befreit",
          industry: "Einzelhandel & Finanzen",
          problem: "Das Monatsende war ein Albtraum für die Buchhaltung: Manuelle Zusammenführung von 14 Excel-Dateien aus 14 Filialen mit chaotischen Formaten. Datenfehler waren an der Tagesordnung, und der CEO kannte den genauen Umsatz erst am 10. des Folgemonats.",
          solution: "Wir eliminierten den manuellen Prozess mit einer automatisierten 'Datenpipeline'. Das System 'saugt' Daten automatisch von den POS-Geräten, bereinigt, standardisiert sie und speist sie jede Nacht in das zentrale Data Warehouse. Finanzberichte werden automatisch um 8 Uhr morgens aktualisiert.",
          result: "Einsparung von 150 Arbeitsstunden/Monat (fast eine ganze Vollzeitkraft). 100% Genauigkeit, der CEO verfolgt den Cashflow täglich auf dem Handy.",
          tags: ["PostgreSQL", "ETL Pipeline", "Finance DB", "Automation"]
        },
        {
          title: "KI liest Verträge statt Anwälte",
          industry: "Recht & Verwaltung",
          problem: "Die Rechtsabteilung war mit Tausenden von Papierverträgen überlastet. Das Nachschlagen einer Klausel im physischen Archiv dauerte Stunden, und das Risiko, nachteilige Klauseln zu übersehen, war sehr hoch.",
          solution: "Einsatz der 'AI Legal Assistant' Lösung auf einem lokalen Server (absolute Sicherheit). Nutzung von OCR- und LLM-Technologie (Ollama) zur Digitalisierung aller Papierdokumente. Mitarbeiter geben Fragen in natürlicher Sprache ein, die KI extrahiert Antworten in 2 Sekunden.",
          result: "Reduzierung der Suchzeit um 80%. Das System warnt automatisch vor auslaufenden Klauseln und hilft dem Unternehmen, rechtliche Risiken in Milliardenhöhe zu vermeiden.",
          tags: ["Local Host AI", "Ollama", "n8n", "OCR", "Doc Automation"]
        }
      ]
    },
    contact: {
      title: "Kontakt für Strategieberatung",
      desc: "Lassen Sie Ihre Daten nicht schlafen. Wir wecken Ihr Potenzial.",
      office: "Büro",
      form: { name: "Name", phone: "Telefon / WhatsApp", company: "Firma", needs: "Aktuelle Herausforderung", btn: "Kostenlose Beratung Anmelden" }
    }
  }
};

// --- Components (Updated to accept translations) ---

const Button = ({ children, primary, onClick, className = "" }) => (
  <button 
    onClick={onClick}
    className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 ${
      primary 
        ? "bg-orange-500 text-white hover:bg-orange-600 border border-transparent" 
        : "bg-white text-blue-900 hover:bg-blue-50 border border-blue-200"
    } ${className}`}
  >
    {children}
  </button>
);

const SectionTitle = ({ subtitle, title, center = true }) => (
  <div className={`mb-12 ${center ? 'text-center' : 'text-left'}`}>
    <span className="text-orange-500 font-bold tracking-wider uppercase text-sm">{subtitle}</span>
    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 leading-tight">
      {title}
    </h2>
    <div className={`h-1.5 w-24 bg-blue-600 mt-4 rounded-full ${center ? 'mx-auto' : ''}`}></div>
  </div>
);

// Updated ServiceCard with dynamic CTA text
const ServiceCard = ({ icon: Icon, title, description, details, ctaText }) => (
  <div className="bg-white p-8 rounded-xl shadow-lg border border-slate-100 hover:border-blue-500 hover:shadow-2xl transition-all duration-300 group h-full flex flex-col">
    <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
      <Icon className="text-blue-600 w-7 h-7 group-hover:text-white transition-colors duration-300" />
    </div>
    <h3 className="text-xl font-bold text-slate-800 mb-3 leading-snug">{title}</h3>
    <p className="text-slate-600 mb-6 leading-relaxed flex-grow text-sm text-justify">{description}</p>
    {details && details.length > 0 && (
      <ul className="space-y-2 mb-6 border-t pt-4 border-slate-100">
        {details.map((item, index) => (
          <li key={index} className="flex items-start text-sm text-slate-700">
            <CheckCircle2 className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    )}
    <a href="#contact" className="text-blue-600 font-semibold flex items-center group-hover:translate-x-2 transition-transform mt-auto">
      {ctaText} <ArrowRight className="w-4 h-4 ml-1" />
    </a>
  </div>
);

// Updated CaseStudyCard with dynamic labels
const CaseStudyCard = ({ icon: Icon, title, industry, problem, solution, result, tags, labels }) => (
  <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-slate-100 flex flex-col h-full">
    <div className="bg-slate-50 p-6 border-b border-slate-100 flex items-start justify-between">
      <div>
        <div className="flex items-center space-x-2 mb-2">
           <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-bold uppercase rounded-full">{industry}</span>
        </div>
        <h3 className="text-xl font-bold text-slate-900 leading-tight">{title}</h3>
      </div>
      <div className="p-3 bg-white rounded-lg shadow-sm text-blue-600">
        <Icon size={24} />
      </div>
    </div>
    <div className="p-6 flex-grow flex flex-col text-sm">
      <div className="mb-4">
        <p className="font-bold text-slate-700 mb-1">{labels.problem}</p>
        <p className="text-slate-600 italic leading-relaxed text-justify">{problem}</p>
      </div>
      <div className="mb-4">
         <p className="font-bold text-slate-700 mb-1">{labels.solution}</p>
         <p className="text-slate-600 leading-relaxed text-justify">{solution}</p>
      </div>
      <div className="mt-auto pt-4 border-t border-slate-100">
        <p className="font-bold text-green-600 flex items-center mb-3">
          <TrendingUp className="w-4 h-4 mr-2" /> {labels.result}
        </p>
        <p className="text-slate-700 font-medium text-justify">{result}</p>
      </div>
    </div>
    <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex flex-wrap gap-2">
      {tags.map((tag, i) => (
        <span key={i} className="text-xs font-medium text-slate-500 bg-white px-2 py-1 rounded border border-slate-200">
          {tag}
        </span>
      ))}
    </div>
  </div>
);

const TechBadge = ({ name }) => (
  <span className="px-3 py-1 bg-slate-100 text-slate-700 rounded text-xs font-medium border border-slate-200 hover:border-blue-400 hover:bg-white hover:text-blue-600 transition-colors cursor-default whitespace-nowrap">
    {name}
  </span>
);

const ProcessStep = ({ number, title, desc, icon: Icon }) => (
    <div className="relative flex flex-col items-center text-center p-6 group">
        <div className="w-16 h-16 bg-white border-2 border-blue-100 rounded-full flex items-center justify-center mb-4 shadow-sm group-hover:border-orange-500 group-hover:bg-orange-50 transition-all z-10">
            <Icon className="w-8 h-8 text-blue-600 group-hover:text-orange-500 transition-colors" />
        </div>
        <div className="absolute top-14 left-1/2 w-full h-0.5 bg-slate-200 -z-0 hidden md:block" style={{ display: number === '04' ? 'none' : '' }}></div>
        <h4 className="text-lg font-bold text-slate-900 mb-2">
            <span className="text-orange-500 mr-2">{number}.</span>{title}
        </h4>
        <p className="text-sm text-slate-600">{desc}</p>
    </div>
);

// --- Main Application ---

export default function App() {
  const [lang, setLang] = useState('vi');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', company: '', email: '', needs: '' });
  const [formStatus, setFormStatus] = useState('idle');

  const t = translations[lang];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormStatus('submitting');

    // MAPPING: Ensure these variables match your EmailJS Template (e.g., {{user_name}})
    const templateParams = {
      user_name: formData.name,
      user_phone: formData.phone,
      user_company: formData.company,
      user_needs: formData.needs,
    };

    // --- YOUR CREDENTIALS ---
    const serviceID = 'service_9redgbe';      // ✅ Your specific ID
    const templateID = 'template_gwtfofc';    // ⚠️ PASTE FROM "EMAIL TEMPLATES" TAB
    const publicKey = 'RAlQfh4Oz76e6ruzD';      // ⚠️ PASTE FROM "ACCOUNT" PAGE (starts with RAIQ...)

    emailjs.send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setFormStatus('success');
        setFormData({ name: '', phone: '', company: '', email: '', needs: '' });
        
        // Reset status message after 5 seconds
        setTimeout(() => setFormStatus('idle'), 5000);
      }, (err) => {
        console.log('FAILED...', err);
        setFormStatus('idle'); // Or 'error' if you have an error state
        alert("Gửi thất bại. Vui lòng thử lại hoặc liên hệ qua Zalo.");
      });
  };

  const processIcons = [Search, BrainCircuit, Settings, Rocket];

  return (
    <div className="font-sans text-slate-700 bg-slate-50 min-h-screen flex flex-col">
      
      {/* --- Navigation --- */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-5'}`}>
        <div className="container mx-auto px-4 md:px-8 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
             <div className="w-10 h-10 bg-blue-700 rounded-lg flex items-center justify-center transform rotate-3 shadow-lg">
              <Workflow className="text-white w-6 h-6" />
            </div>
            <div>
              <h1 className={`font-bold text-xl leading-none tracking-tight ${isScrolled ? 'text-slate-900' : 'text-slate-900 md:text-white'}`}>ĐỘNG LỰC SỐ</h1>
              <span className={`text-xs font-bold tracking-widest ${isScrolled ? 'text-orange-500' : 'text-orange-500 md:text-orange-300'}`}>DONGLUCSO.COM</span>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className={`hidden lg:flex items-center space-x-6 font-medium ${isScrolled ? 'text-slate-600' : 'text-slate-100'}`}>
            <button onClick={() => handleNavClick('about')} className="hover:text-orange-400 transition-colors">{t.nav.about}</button>
            <button onClick={() => handleNavClick('services')} className="hover:text-orange-400 transition-colors">{t.nav.services}</button>
            <button onClick={() => handleNavClick('haiphong')} className="hover:text-orange-400 transition-colors flex items-center gap-1"><MapPin size={14}/>{t.nav.haiphong}</button>
            <button onClick={() => handleNavClick('casestudies')} className="hover:text-orange-400 transition-colors">{t.nav.projects}</button>
            <button onClick={() => handleNavClick('process')} className="hover:text-orange-400 transition-colors">{t.nav.process}</button>
            <button onClick={() => handleNavClick('contact')} className="hover:text-orange-400 transition-colors">{t.nav.contact_menu}</button>
            
            <div className="flex items-center space-x-2 border-l pl-6 border-slate-400/30">
               <button onClick={() => setLang('vi')} className={`text-xs font-bold px-2 py-1 rounded ${lang === 'vi' ? 'bg-orange-500 text-white' : 'hover:bg-white/20'}`}>VN</button>
               <button onClick={() => setLang('en')} className={`text-xs font-bold px-2 py-1 rounded ${lang === 'en' ? 'bg-orange-500 text-white' : 'hover:bg-white/20'}`}>EN</button>
               <button onClick={() => setLang('de')} className={`text-xs font-bold px-2 py-1 rounded ${lang === 'de' ? 'bg-orange-500 text-white' : 'hover:bg-white/20'}`}>DE</button>
               <button onClick={() => setLang('ko')} className={`text-xs font-bold px-2 py-1 rounded ${lang === 'ko' ? 'bg-orange-500 text-white' : 'hover:bg-white/20'}`}>KO</button>
            </div>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block ml-4">
            <button 
              onClick={() => handleNavClick('contact')}
              className="px-6 py-3 rounded-lg font-semibold bg-orange-500 text-white hover:bg-orange-600 border-none shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300"
            >
              {t.nav.quote}
            </button>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden text-slate-800" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X /> : <Menu className={!isScrolled ? 'text-white' : 'text-slate-900'} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t py-4 px-4 flex flex-col space-y-4">
            <div className="flex justify-center space-x-4 mb-4 pb-4 border-b border-slate-100">
               <button onClick={() => setLang('vi')} className={`text-sm font-bold px-3 py-1 rounded ${lang === 'vi' ? 'bg-blue-600 text-white' : 'bg-slate-100'}`}>VN</button>
               <button onClick={() => setLang('en')} className={`text-sm font-bold px-3 py-1 rounded ${lang === 'en' ? 'bg-blue-600 text-white' : 'bg-slate-100'}`}>EN</button>
               <button onClick={() => setLang('de')} className={`text-sm font-bold px-3 py-1 rounded ${lang === 'de' ? 'bg-blue-600 text-white' : 'bg-slate-100'}`}>DE</button>
               <button onClick={() => setLang('ko')} className={`text-sm font-bold px-3 py-1 rounded ${lang === 'ko' ? 'bg-blue-600 text-white' : 'bg-slate-100'}`}>KO</button>
            </div>
            <button onClick={() => handleNavClick('about')} className="text-left py-2 font-medium text-slate-700">{t.nav.about}</button>
            <button onClick={() => handleNavClick('services')} className="text-left py-2 font-medium text-slate-700">{t.nav.services}</button>
            <button onClick={() => handleNavClick('haiphong')} className="text-left py-2 font-medium text-slate-700">{t.nav.haiphong}</button>
            <button onClick={() => handleNavClick('casestudies')} className="text-left py-2 font-medium text-slate-700">{t.nav.projects}</button>
            <button onClick={() => handleNavClick('process')} className="text-left py-2 font-medium text-slate-700">{t.nav.process}</button>
            <button onClick={() => handleNavClick('contact')} className="text-left py-2 font-bold text-orange-600">{t.nav.quote}</button>
          </div>
        )}
      </nav>

      {/* --- Hero Section --- */}
      <header className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-blue-900">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-slate-900"></div>
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
        
        <div className="container mx-auto px-4 relative z-10 text-center md:text-left">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-3/5 mb-10 md:mb-0">
              <div className="inline-block px-4 py-1 bg-blue-800/50 rounded-full border border-blue-500 mb-6">
                <span className="text-blue-200 text-sm font-semibold tracking-wide uppercase flex items-center gap-2">
                    <Award className="w-4 h-4 text-yellow-400" /> {t.hero.badge}
                </span>
              </div>
              <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
                {t.hero.title_prefix} <br/>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-300">{t.hero.title_highlight}</span>
              </h1>
              <p className="text-lg md:text-xl text-blue-100 mb-8 max-w-2xl leading-relaxed">
                 {t.hero.desc}
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 justify-center md:justify-start">
                <Button primary onClick={() => handleNavClick('services')} className="bg-orange-500 hover:bg-orange-600 border-none text-white shadow-lg">
                  {t.hero.btn_primary}
                </Button>
                <Button onClick={() => handleNavClick('about')} className="bg-white text-blue-900 hover:bg-blue-50 border-transparent shadow-lg">
                  {t.hero.btn_secondary}
                </Button>
              </div>
            </div>
            
            {/* Hero Illustration - UPDATED BADGE & STATUS BOX */}
            <div className="md:w-2/5 relative hidden md:block">
              <div className="relative z-10 rounded-2xl p-2 border border-white/20 shadow-2xl bg-white/10 backdrop-blur-sm">
                 {/* Dashboard Image Container */}
                 <div 
                    className="rounded-xl h-80 relative overflow-hidden border border-slate-700 bg-cover bg-center shadow-inner group"
                    style={{ 
                        backgroundImage: "url('https://medevel.com/content/images/2021/08/1-2.png')" 
                    }}
                 >
                    {/* Dark overlay to make UI pop */}
                    <div className="absolute inset-0 bg-slate-900/70 transition-all duration-500"></div>
                    
                    {/* --- STATUS GLASS BOX (Big Data, AI, Kafka) --- */}
                    <div className="absolute inset-0 flex items-center justify-center z-30 pointer-events-none p-6">
                        <div className="bg-slate-900/90 backdrop-blur-md border border-slate-700 rounded-xl p-4 shadow-2xl w-full max-w-sm transform group-hover:scale-105 transition-all duration-500">
                           
                           {/* Row 1: Big Data & AI */}
                           <div className="grid grid-cols-2 gap-3 mb-3">
                              {/* Big Data Box */}
                              <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-3">
                                 <div className="text-xs text-blue-200 mb-2 font-medium">Big Data</div>
                                 <div className="h-1.5 w-full bg-slate-700 rounded-full overflow-hidden">
                                    <div className="h-full bg-blue-500 w-[75%] rounded-full shadow-[0_0_8px_rgba(59,130,246,0.6)] animate-pulse"></div>
                                 </div>
                              </div>
                              
                              {/* AI Models Box */}
                              <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-3">
                                 <div className="text-xs text-green-200 mb-2 font-medium">AI Models</div>
                                 <div className="h-1.5 w-full bg-slate-700 rounded-full overflow-hidden">
                                    <div className="h-full bg-green-500 w-[60%] rounded-full shadow-[0_0_8px_rgba(34,197,94,0.6)]"></div>
                                 </div>
                              </div>
                           </div>

                           {/* Row 2: Kafka Stream */}
                           <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-3">
                              <div className="text-[10px] text-slate-400 mb-1 uppercase tracking-wider font-semibold">Real-time Processing</div>
                              <div className="flex items-center gap-2.5">
                                 <div className="relative flex h-2.5 w-2.5">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                                 </div>
                                 <span className="text-sm font-bold text-white font-mono tracking-tight">Kafka Stream Active</span>
                              </div>
                           </div>

                        </div>
                    </div>

                    {/* --- NEW: UPDATED AWARD BADGE (Matches Reference Image) --- */}
                    <div className="absolute top-6 left-6 z-20 flex items-center gap-3 animate-fade-in group-hover:opacity-100 transition-opacity">
                        {/* Yellow Circle */}
                        <div className="w-12 h-12 rounded-full bg-[#FFC107] flex items-center justify-center shadow-lg flex-shrink-0">
                            <span className="text-slate-900 font-bold text-xl">1st</span>
                        </div>
                        {/* Text Group */}
                        <div className="flex flex-col justify-center">
                            <span className="text-slate-400 text-[10px] font-bold tracking-widest uppercase leading-tight mb-0.5">AWARD</span>
                            <span className="text-white font-bold text-base leading-tight drop-shadow-md">Smart Factory 4.0</span>
                        </div>
                    </div>
                    {/* -------------------------------------------------------- */}

                  </div>
              </div>
            </div>
			
          </div>
        </div>
      </header>

      {/* --- ABOUT PROFILE SECTION --- */}
      <section id="about" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <SectionTitle subtitle={t.about.subtitle} title={t.about.title} center={true} />

          <div className="flex flex-col lg:flex-row gap-12 items-start">
             {/* Left: Image & Basic Info */}
             <div className="lg:w-1/3 w-full">
                <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 shadow-lg text-center relative overflow-hidden group">
                   <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-black via-red-600 to-yellow-500"></div>
                   
                   {/* PROFILE IMAGE */}
                   <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white shadow-md relative group-hover:border-blue-200 transition-all">
                       <img 
                           src="https://res.cloudinary.com/dkhbfpxqs/image/upload/v1763710662/PVGG0326_m5hqhw.jpg"
                           alt="Chuyên gia Phu Viet" 
                           className="w-full h-full object-cover"
                           onError={(e) => {e.target.onerror = null; e.target.src = "https://via.placeholder.com/200?text=User"}}
                       />
                   </div>

                   <h3 className="text-2xl font-bold text-slate-900">Phu Viet</h3>
                   <p className="text-blue-600 font-medium mb-4">{t.about.role}</p>
                   
                    <div className="inline-flex items-center gap-2 bg-blue-50 px-4 py-2 rounded-full text-sm font-semibold text-blue-800 mb-6">
                      <Globe className="w-4 h-4" /> {t.about.exp}
                   </div>

                   <div className="flex justify-center gap-4 border-t pt-6 border-slate-200">
                        <div className="text-center">
                           <div className="font-bold text-slate-900 text-xl">10+</div>
                           <div className="text-xs text-slate-500">Years</div>
                       </div>
                        <div className="w-px bg-slate-200"></div>
                       <div className="text-center">
                           <div className="font-bold text-slate-900 text-xl">DE</div>
                           <div className="text-xs text-slate-500">Market</div>
                       </div>
                       <div className="w-px bg-slate-200"></div>
                       <div className="text-center">
                           <div className="font-bold text-slate-900 text-xl">3rd</div>
                           <div className="text-xs text-slate-500">AI Prize</div>
                       </div>
                   </div>
                </div>
              </div>

             {/* Right: Details */}
             <div className="lg:w-2/3 w-full">
                <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100 mb-8">
                    <h4 className="text-xl font-bold text-blue-900 mb-3 flex items-center">
                        <Zap className="w-6 h-6 text-orange-500 mr-2" /> {t.about.intro}
                    </h4>
                    <p className="text-slate-700 leading-relaxed mb-4 italic text-justify">
                        "{t.about.story}"
                     </p>
                    <div className="flex items-start mt-4 pt-4 border-t border-blue-200">
                         <Users className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-1" />
                          <p className="text-slate-700 text-sm text-justify">{t.about.team_intro}</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6 mb-10">
                    {t.about.points.map((point, idx) => (
                         <div key={idx} className="bg-white p-4 rounded-lg border-l-4 border-blue-500 shadow-sm hover:shadow-md transition-all">
                            <h5 className="font-bold text-slate-800 mb-1">{point.title}</h5>
                            <p className="text-sm text-slate-600 leading-relaxed text-justify">{point.desc}</p>
                         </div>
                    ))}
                </div>

                <h4 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
                    <Code2 className="w-6 h-6 text-blue-600 mr-2" /> {t.about.tech_title}
                 </h4>
                
                <div className="space-y-4">
                    <div>
                        <div className="text-sm font-bold text-slate-500 mb-2 uppercase tracking-wider">{t.about.tech_groups.warehouse}</div>
                         <div className="flex flex-wrap gap-2">
                            <TechBadge name="3NF" /> <TechBadge name="Kimball" /> <TechBadge name="Data Vault 2.0" /> <TechBadge name="SAP Power Designer" /> <TechBadge name="Linux" /> <TechBadge name="Docker" />
                        </div>
                     </div>
                    <div>
                        <div className="text-sm font-bold text-slate-500 mb-2 uppercase tracking-wider">{t.about.tech_groups.db}</div>
                        <div className="flex flex-wrap gap-2">
                             <TechBadge name="MS SQL Server (SSIS/SSAS)" /> <TechBadge name="PostgreSQL" /> <TechBadge name="MySQL" /> <TechBadge name="Redshift" /> <TechBadge name="Azure" /> <TechBadge name="AWS" />
                        </div>
                    </div>
                    <div>
                         <div className="text-sm font-bold text-slate-500 mb-2 uppercase tracking-wider">{t.about.tech_groups.bi}</div>
                        <div className="flex flex-wrap gap-2">
                            <TechBadge name="Tableau Desktop/Server" /> <TechBadge name="Power BI" /> <TechBadge name="Qlikview" />
                         </div>
                    </div>
                    <div>
                        <div className="text-sm font-bold text-slate-500 mb-2 uppercase tracking-wider">{t.about.tech_groups.auto}</div>
                         <div className="flex flex-wrap gap-2">
                            <TechBadge name="Python" /> <TechBadge name="n8n" /> <TechBadge name="Power Automate" /> <TechBadge name="Ollama AI (Local)" /> <TechBadge name="OCR" /> <TechBadge name="Azure Functions" />
                        </div>
                     </div>
                </div>
             </div>
          </div>
        </div>
      </section>

      {/* --- Services --- */}
      <section id="services" className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
            <SectionTitle subtitle={t.services.subtitle} title={t.services.title} />
            <div className="grid md:grid-cols-3 gap-8">
               <ServiceCard 
                  icon={BarChart3} 
                  title={t.services.items[0].title} 
                  description={t.services.items[0].desc} 
                  details={t.services.items[0].details}
                  ctaText={t.common.consult_now}
               />
               <ServiceCard 
                  icon={Database} 
                  title={t.services.items[1].title} 
                  description={t.services.items[1].desc} 
                  details={t.services.items[1].details}
                  ctaText={t.common.consult_now}
               />
               <ServiceCard 
                  icon={Workflow} 
                  title={t.services.items[2].title} 
                  description={t.services.items[2].desc} 
                  details={t.services.items[2].details}
                  ctaText={t.common.consult_now}
               />
            </div>
        </div>
      </section>

      {/* --- NEW: HAI PHONG SECTION (UPDATED BACKGROUND) --- */}
      <section 
        id="haiphong" 
        className="py-20 text-white relative overflow-hidden bg-cover bg-center bg-no-repeat bg-fixed"
        style={{ backgroundImage: "url('https://mlc-ttl.com/wp-content/uploads/2021/09/CANG-HAIPHONG.jpg')" }}
      >
        {/* Dark Blue Overlay - Ensures text is readable on top of the photo */}
        <div className="absolute inset-0 bg-blue-900/85"></div>
        
        {/* The rest of the content stays exactly the same... */}
        <div className="container mx-auto px-4 relative z-10">
           {/* ... existing content ... */}
           <div className="text-center mb-12">
              <span className="text-orange-400 font-bold tracking-wider uppercase text-sm">{t.haiphong.subtitle}</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-2">{t.haiphong.title}</h2>
              <div className="h-1.5 w-24 bg-orange-500 mt-4 rounded-full mx-auto"></div>
              <p className="mt-6 text-blue-100 max-w-2xl mx-auto">{t.haiphong.desc}</p>
           </div>

           <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Left: Map Visual - UPDATED WITH GLASS BORDER & PIN */}
              <div className="relative group">
                  {/* 1. The Glass Frame Container */}
                  <div className="relative p-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl shadow-2xl">
                     
                     {/* 2. Image Wrapper with Round Corners & Zoom Effect */}
                     <div className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-inner">
                        <img 
                           src="https://img.tripi.vn/cdn-cgi/image/width=700,height=700/https://gcs.tripi.vn/public-tripi/tripi-feed/img/473752OCO/cong-ty-cp-nhiet-dien-hai-phong-665143.jpg" 
                           alt="Cảng Hải Phòng" 
                           className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                        />
                        {/* Gradient Overlay to make the image look deeper */}
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent"></div>
                     </div>

                     {/* 3. The Map Pin & Label Overlay */}
                     <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center z-20 w-full">
                        
                        {/* Pulsing Pin Icon */}
                        <div className="relative mb-3 group-hover:-translate-y-2 transition-transform duration-300">
                           <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
                           <div className="relative p-3 bg-orange-500 rounded-full border-4 border-white/30 shadow-2xl text-white">
                              <MapPin size={28} fill="currentColor" />
                           </div>
                        </div>

                        {/* The Text Label */}
                        <div className="px-5 py-2.5 bg-slate-900/80 backdrop-blur-md border border-white/10 rounded-full shadow-xl">
                           <p className="text-white font-bold text-sm tracking-wide flex items-center gap-2 whitespace-nowrap">
                              Hai Phong - Industrial & Port city
                           </p>
                        </div>
                     </div>
                  </div>

                  {/* Decorative Glows Behind the Frame */}
                  <div className="absolute -top-5 -left-5 w-32 h-32 bg-blue-500/30 rounded-full blur-2xl -z-10"></div>
                  <div className="absolute -bottom-5 -right-5 w-32 h-32 bg-orange-500/30 rounded-full blur-2xl -z-10"></div>
              </div>

              {/* Right: Solutions */}
              <div className="space-y-6">
                 {t.haiphong.solutions.map((sol, idx) => (
                    <div key={idx} className="flex gap-4 p-4 rounded-xl bg-white/10 hover:bg-white/20 transition-colors border border-white/10">
                       <div className="w-12 h-12 rounded-lg bg-orange-500 flex items-center justify-center flex-shrink-0">
                          {idx === 0 ? <Anchor className="w-6 h-6 text-white"/> : <Factory className="w-6 h-6 text-white"/>}
                       </div>
                       <div>
                          <h4 className="text-xl font-bold mb-2 text-white">{sol.title}</h4>
                          <p className="text-blue-100 text-sm mb-3">{sol.desc}</p>
                          <div className="flex flex-wrap gap-2">
                             {sol.features.map((f, i) => (
                                <span key={i} className="px-2 py-1 bg-blue-900/50 rounded text-xs text-blue-200 border border-blue-700">{f}</span>
                             ))}
                          </div>
                       </div>
                    </div>
                 ))}
              </div>
           </div>
        </div>
      </section>

      {/* --- PROCESS (QUY TRÌNH) --- */}
      <section id="process" className="py-20 bg-white">
          <div className="container mx-auto px-4">
              <SectionTitle subtitle={t.process.subtitle} title={t.process.title} center={true} />
              
              <div className="grid md:grid-cols-4 gap-8 mt-12">
                  {t.process.steps.map((step, index) => (
                    <ProcessStep 
                      key={index}
                      number={step.number}
                      title={step.title}
                      desc={step.desc}
                      icon={processIcons[index]}
                    />
                  ))}
              </div>
          </div>
      </section>

      {/* --- Case Studies --- */}
      <section id="casestudies" className="py-20 bg-slate-50 relative">
        <div className="absolute inset-0 bg-white transform -skew-y-3 z-0 origin-top-left scale-110"></div>
        <div className="container mx-auto px-4 relative z-10">
          <SectionTitle 
            subtitle={t.casestudies.subtitle} 
            title={t.casestudies.title} 
            center={true}
          />
          
          <div className="grid md:grid-cols-3 gap-8">
            {t.casestudies.items.map((item, index) => (
              <CaseStudyCard 
                 key={index}
                 icon={[Factory, Calculator, BrainCircuit][index]}
                 title={item.title}
                 industry={item.industry}
                 problem={item.problem}
                 solution={item.solution}
                 result={item.result}
                 tags={item.tags}
                 labels={t.common}
              />
            ))}
          </div>
        </div>
      </section>

      {/* --- Contact Section --- */}
      <section id="contact" className="py-20 container mx-auto px-4">
         <div className="bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row border border-slate-100">
            <div className="md:w-2/5 bg-blue-900 text-white p-10 flex flex-col justify-between relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full"></div>
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-orange-500/10 rounded-tr-full"></div>
                
                <div className="relative z-10">
                    <h3 className="text-3xl font-bold mb-6">{t.contact.title}</h3>
                    <p className="text-blue-200 mb-8">{t.contact.desc}</p>
                    
                    <div className="space-y-6">
                        <div className="flex items-start">
                            <MapPin className="w-6 h-6 text-orange-400 mr-4 mt-1" />
                            <div>
                                <p className="font-bold">{t.contact.office}</p>
                                <p className="text-sm text-blue-200">số 137 Phố Tân Thành, Dương Kinh, Hải Phòng</p>
                            </div>
                         </div>
                        <div className="flex items-center">
                            <Phone className="w-6 h-6 text-orange-400 mr-4" />
                             <div>
                                <p className="font-bold">Hotline / Zalo</p>
                                <p className="text-sm text-blue-200">0793 661 657  (Mr. Việt)</p>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <Mail className="w-6 h-6 text-orange-400 mr-4" />
                            <div>
                                <p className="font-bold">Email</p>
                                <p className="text-sm text-blue-200">contact@donglucso.com</p>
                            </div>
                        </div>
                    </div>
                </div>
                 
                <div className="mt-12 flex space-x-4 relative z-10">
                    <a href="#" className="w-10 h-10 rounded-full bg-blue-800 flex items-center justify-center hover:bg-orange-500 transition-colors"><Facebook size={20}/></a>
                    <a href="#" className="w-10 h-10 rounded-full bg-blue-800 flex items-center justify-center hover:bg-orange-500 transition-colors"><Linkedin size={20}/></a>
                </div>
            </div>

            <div className="md:w-3/5 p-10 bg-white">
                {formStatus === 'success' ? (
                    <div className="h-full flex flex-col items-center justify-center text-center animate-fade-in">
                        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
                            <CheckCircle2 className="w-10 h-10 text-green-600" />
                        </div>
                        <h3 className="text-2xl font-bold text-slate-800 mb-2">Gửi thành công!</h3>
                        <p className="text-slate-500">Cảm ơn bạn đã quan tâm. Đội ngũ Động Lực Số sẽ liên hệ lại trong vòng 24h.</p>
                     </div>
                ) : (
                    <form onSubmit={handleFormSubmit} className="space-y-6">
                        <div className="grid md:grid-cols-2 gap-6">
                             <div>
                                <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.form.name}</label>
                                <input 
                                    required 
                                    type="text" 
                                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                    placeholder="Name..."
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.form.phone}</label>
                                <input 
                                    required 
                                    type="tel" 
                                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                    placeholder="+84..."
                                    value={formData.phone}
                                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                 />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.form.company}</label>
                            <input 
                                type="text" 
                                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                value={formData.company}
                                onChange={(e) => setFormData({...formData, company: e.target.value})}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">{t.contact.form.needs}</label>
                            <select 
                                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all bg-white"
                                value={formData.needs}
                                onChange={(e) => setFormData({...formData, needs: e.target.value})}
                            >
                                <option value="">Select...</option>
                                <option value="powerbi">Power BI / Tableau</option>
                                <option value="database">Database / Data Warehouse</option>
                                <option value="automation">Automation / AI</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                        <button 
                            type="submit" 
                            disabled={formStatus === 'submitting'}
                            className="w-full bg-orange-500 text-white font-bold py-4 rounded-lg hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl flex items-center justify-center"
                        >
                            {t.contact.form.btn}
                        </button>
                    </form>
                )}
            </div>
         </div>
      </section>

      {/* --- Footer --- */}
      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
        <div className="container mx-auto px-4 text-center">
            <div className="flex justify-center items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
                    <Workflow className="text-white w-5 h-5" />
                </div>
                <span className="font-bold text-xl text-white">ĐỘNG LỰC SỐ</span>
            </div>
            <p className="text-sm">
                Expertise from Germany, Solutions for Vietnam.
             </p>
            <div className="border-t border-slate-800 mt-8 pt-8 text-sm">
                &copy; {new Date().getFullYear()} DongLucSo.com. All rights reserved.
            </div>
        </div>
      </footer>

      {/* Floating Zalo Button - Fixed Link */}
      <a 
        href="https://zalo.me/84793661657" 
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-2xl hover:-translate-y-1 transition-all duration-300 border-2 border-white flex items-center group"
      >
        <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full absolute -top-2 -right-2 animate-bounce">1</span>
        <span className="font-bold mr-2 max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 ease-in-out whitespace-nowrap">Chat Zalo</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px" fill="currentColor"><path d="M24 4C12.95 4 4 12.95 4 24c0 11.05 8.95 20 20 20 11.05 0 20-8.95 20-20C44 12.95 35.05 4 24 4z" opacity=".1"/><path fill="#fff" d="M24 5C13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19S34.5 5 24 5zm0 36c-9.4 0-17-7.6-17-17S14.6 7 24 7s17 7.6 17 17-7.6 17-17 17z"/><path fill="#fff" d="M29.4 26.7h-5.9l2.8-3.7c.4-.6.5-1.3.1-1.9-.3-.4-.8-.7-1.3-.7h-4.2c-1 0-1.8.8-1.8 1.8 0 1 .8 1.8 1.8 1.8h2.9l-2.8 3.7c-.4.6-.5 1.3-.1 1.9.3.4.8.7 1.3.7h7.1c1 0 1.8-.8 1.8-1.8C31.2 27.5 30.4 26.7 29.4 26.7z"/></svg>
      </a>

    </div>
  );
}
